export const DISPLAY_ALERT = "DISPLAY_ALERT";
export const CLEAR_ALERT = "CLEAR_ALERT";
export const HANDLE_CHANGE = "HANDLE_CHANGE";


